import api from "config/api";
import { AppDispatch, RootState } from "store";
import { setAllCartData, setCartBtnLoading } from "store/slices/main.slice";

const sanitizeCartPayload = (value: any): any => {
  const seen = new WeakMap<object, any>();
  const omitKeys = new Set([
    "sourceDealPizza",
    "existingFullNote",
    "existingPizzaSize",
    "existingSizePrice",
    "existingPizzaCrust",
    "existingSpiceLevel",
    "existingSubTotal",
    "legacyQuantity",
    "selected",
  ]);

  const visit = (input: any): any => {
    if (input === null || typeof input !== "object") return input;
    if (seen.has(input)) return seen.get(input);

    if (
      input?.selected === false &&
      (Object.prototype.hasOwnProperty.call(input, "pizzaModifierId") ||
        Object.prototype.hasOwnProperty.call(input, "modifierId"))
    ) {
      return undefined;
    }

    if (Array.isArray(input)) {
      const arr = input.map(visit).filter((item) => item !== undefined);
      seen.set(input, arr);
      return arr;
    }

    const out: any = {};
    seen.set(input, out);

    Object.keys(input).forEach((key) => {
      if (omitKeys.has(key)) return;
      if (key === "pizzaRegion") {
        out.PizzaRegion = visit(input[key]);
        return;
      }
      out[key] = visit(input[key]);
    });

    if (
      (Object.prototype.hasOwnProperty.call(out, "productId") ||
        Object.prototype.hasOwnProperty.call(out, "id")) &&
      !Object.prototype.hasOwnProperty.call(out, "prodcat")
    ) {
      out.prodcat =
        input?.prodcat ??
        input?.prodCat ??
        input?.categoryId ??
        input?.__categoryId ??
        input?.data?.prodcat ??
        input?.data?.prodCat ??
        input?.data?.categoryId ??
        input?.data?.__categoryId ??
        0;
    }

    if (
      Object.prototype.hasOwnProperty.call(out, "modifierId") &&
      Object.prototype.hasOwnProperty.call(out, "quantity")
    ) {
      const multiplier = Math.max(
        1,
        Number(input?.Multiplier || input?.DtltoppMultiplier || input?.legacyQuantity || 1)
      );
      // Cart API model expects an integer. Final order submit keeps the 0.5 side quantity.
      out.quantity = multiplier;
      out.isMultiplier =
        Number(input?.isMultiplier ?? input?.DtltoppIsmultiplier ?? (multiplier > 1 ? 1 : 0)) || 0;
      out.Multiplier = multiplier;
      delete out.DtltoppIsmultiplier;
      delete out.DtltoppMultiplier;
    }

    return out;
  };

  return visit(value);
};

export const addUpdateToCart =
  (item: any, onClose: () => void) =>
  (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(setCartBtnLoading(true));

    const state = getState();
    const userId = state?.main?.userData?.clientId;

    if (!userId) {
      if (item?.data.isEdit) {
        const updatedCart = [...state.main.cart];
        updatedCart[item.data.index] = {
          ...item,
          cartId: state.main.cart[item.data.index].cartId,
        };
        dispatch(setAllCartData(updatedCart));
      } else {
        dispatch(setAllCartData([...state.main.cart, { ...item, cartId: 0 }]));
      }
      onClose();
      dispatch(setCartBtnLoading(false));
      // toast.error("User not authenticated");
      return;
    }

    if (item?.data.isEdit) {
      const sanitizedItem = sanitizeCartPayload(item);
      api
        .post("/api/Cart/UpdateCart", [
          {
            ...sanitizedItem,
            cartId: state.main.cart[item.data.index].cartId,
            userId,
          },
        ])
        .then(({ data }) => {
          const updatedCart = [...state.main.cart];
          updatedCart[item.data.index] = {
            ...item,
            cartId: state.main.cart[item.data.index].cartId,
          };
          dispatch(setAllCartData(updatedCart));
          onClose();

          console.log("Updated cart", data);
        })
        .catch((e) => {
          console.log("Error updating cart", e);
          // toast.error("Something went wrong while updating cart");
        })
        .finally(() => {
          dispatch(setCartBtnLoading(false));
        });
    } else {
      const sanitizedItem = sanitizeCartPayload(item);
      api
        .post("/api/Cart/AddCart", [{ ...sanitizedItem, cartId: 0, userId }])
        .then(({ data }) => {
          if (data.orderId) {
            dispatch(
              setAllCartData([
                ...state.main.cart,
                { ...item, cartId: data.orderId },
              ])
            );
            onClose();

            console.log("Added to cart", data);
          }
        })
        .catch((e) => {
          console.log("Error adding to cart", e);
          // toast.error("Something went wrong while adding to cart");
        })
        .finally(() => {
          dispatch(setCartBtnLoading(false));
        });
    }
  };
